import Vue from 'vue';
import App from './App.vue';
import vuetify from './plugins/vuetify';
import i18n from './i18n';
import store from './store';
import setupInterceptors from './helpers/axios_interceptors';

Vue.config.productionTip = false;

setupInterceptors();

new Vue({
  vuetify,
  i18n,
  store,
  render: (h) => h(App),
}).$mount('#app');
